import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { environment } from "../environment";
import { MachineStatus } from "../models/machines.model";
import { BulkAddDevicesTable } from "../shared/Tables/BulkAddTable";
import { DevicesTable } from "../shared/Tables/DevicesTable";
import { csvToJSON } from "../utils/csvToJSON.util";
import { DateUtil } from "../utils/date.util";
import { useAxios } from "./useAxios";
//import groupBy from 'lodash/groupBy';
//import values from "lodash/values";

//DEMO 1 - TEMPORAY HARDCODED
import adrianstucki from "../mock/Devices/adrian.stucki.json";
import alexandraklee from "../mock/Devices/alexandra.klee.json";
import jensheiringhoff from "../mock/Devices/jens.heiringhoff.json";
import michaelboostbar from "../mock/Devices/michael.boostbar.json";

import { toast } from "react-toastify";
import { useUserContext } from "../context/user.context";
import { DASHBOARD_ROUTES } from "../router/RoutesEnum";
import { EMPTY_DATA_DASH } from "../constants";

export const usePOS = () => {
  //DEMO 1 - TEMPORAY HARDCODED
  const DEMO1_EMAILS = [
    { email: "jens.heiringhoff@tchibo-coffeeservice.de", json: jensheiringhoff },
    { email: "alexandra@cafimat.ch", json: alexandraklee },
    { email: "adrian.stucki@nurissa.ch", json: adrianstucki },
    { email: "michael@boostbar.ch", json: michaelboostbar },
    //{ email: "simon.brunner@brister.ch", json: simonbrunner },

    // { email: "patricija.furdi@smarpay.eu", json: michaelboostbar } //TEST EMAIL - DONT FORGET TO COMMENT OUT!!!
  ];

  const { t } = useTranslation();

  //const format = "dd.MM.yyyy HH:mm:ss";

  const { initialized, keycloak } = useKeycloak();
  const kcToken = keycloak?.token || "";

  //const { email } = useKeycloakData()
  const { axiosInstance } = useAxios();

  const { merchantId } = useUserContext();

  const navigate = useNavigate();

  const [machinesData, setMachineData] = useState([]);
  const [filteredMachineData, setFilteredMachineData] = useState([]);

  const [totalNumberOfDevices, setTotalNumberOfDevices] = useState(0);
  const [totalWorking, setTotalWorking] = useState(0);
  const [totalWarning, setTotalWarning] = useState(0);
  const [totalError, setTotalError] = useState(0);
  const [totalUnknown, setTotalUnknown] = useState(0);
  const [machineAddStatus, setMachineAddStatus] = useState(false);

  //FILTERS FROM 01 CURENT MONTH till TODAY
  const [startDate, setStartDate] = useState(DateUtil.firstDayOfCurrentMonth);
  const [endDate, setEndDate] = useState(new Date());

  const [machineStatuses, setMachineStatuses] = useState(["Select Machine Status"]);
  const [machineNames, setMachineNames] = useState(["Select Machine name"]);
  const [machineCities, setMachineCities] = useState(["Select Machine City"]);
  const [machineGroup, setmachineGroup] = useState(["Select machine group"]);

  const [devicesTableData, setDevicesTableData] = useState([]);
  const [bulkTableData, setBulkTableData] = useState([]);
  const [allRows, setAllDevices] = useState(0);
  const [selectedRows, setSelectedDevicesLength] = useState(0);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [editableMachine, setEditableMachine] = useState([]);

  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finish, setFinish] = useState(false);
  const [finishEdit, setFinishEdit] = useState(false);

  const [postingFlag, setPostingFlag] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalForDelete, setOpenModalForDelete] = useState(false);
  const [isRequestGood, setIsRequestGood] = useState(null);

  const [areMachinesVisible, setAreMachinesVisible] = useState(true);

  //CREATION OF DEVICES
  const renderBulkTable = () => {
    return <BulkAddDevicesTable bulkTableData={bulkTableData} />;
  };

  const ShowToastMessage = (text) =>
    toast(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{text}</p>, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    });

  const addNewDeviceData = (csvData) => {
    const toJson = csvToJSON(csvData);
    setBulkTableData(toJson);
  };

  const getmachineGroup = (merchant) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.machineGroupEndpoint}`;

    axiosInstance?.current?.get(url).then((res) => {
      //console.log("MACHINE GROUPS => ", res);
      setmachineGroup([res?.data].flat());
    }).catch((err) => {
      if (err?.response?.status === 500) {
        ShowToastMessage(t("toastr.pos.machineGroup") + t("toastr.general.cantShow.error500"));
      } else if (err?.response?.status === 401) {
        ShowToastMessage(t("toastr.pos.machineGroup") + t("toastr.general.cantShow.error401"));
      } else if (err?.response?.status === 404) {
        ShowToastMessage(t("toastr.pos.machineGroup") + t("toastr.general.cantShow.error404"));
      } else if (err?.response?.status === 204) {
        ShowToastMessage(t("toastr.pos.machineGroup") + t("toastr.general.cantShow.error204"));
      }
    });
  };

  const postBulkMachineEndpoint = () => {
    let dataForPosting = selectedDevices;

    if (dataForPosting.length !== 0) {
      const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.addPosDevices}`;
      setPostingFlag(true);
      setIsRequestGood(false);
      const config = {
        headers: {
          Authorization: initialized ? `Bearer ${kcToken}` : undefined,
        },
      };
      const formatedData = dataForPosting.map((element) => {
        !element?.longitude ? (element.longitude = 0) : (element.longitude = parseFloat(element.longitude));
        element?.latitude === "" ? (element.latitude = 0) : (element.latitude = parseFloat(element.latitude));
        element?.zipCode === "" ? (element.zipCode = 0) : (element.zipCode = parseFloat(element.zipCode));
        delete element["\r"];
        return element;
      });
      axiosInstance?.current
        ?.post(url, formatedData, config)
        .then((res) => {
          setSelectedDevices([]);
          setOpenModal(true);
          setFinish(false);
          console.log(res);
        })
        .catch((err) => {
          setFinish(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.pos.bulkUpload") + t("toastr.general.failed.error500") + t("toastr.devices.duplicates"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.pos.bulkUpload") + t("toastr.general.failed.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.pos.bulkUpload") + t("toastr.general.failed.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.pos.bulkUpload") + t("toastr.general.failed.error204"));
          }
          console.log(err);
        });
    }
  };

  const postNewMachineEndpoint = (data) => {
    let dataForPosting = [data];
    if (dataForPosting.length !== 0) {
      const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.addPosDevices}`;
      const config = {
        headers: {
          Authorization: initialized ? `Bearer ${kcToken}` : undefined,
        },
      };
      dataForPosting[0].longitude === "" ? dataForPosting[0].longitude = 0 : parseFloat(dataForPosting[0].longitude);
      dataForPosting[0].latitude === "" ? dataForPosting[0].latitude = 0 : parseFloat(dataForPosting[0].latitude);
      dataForPosting[0].zipCode === "" ? dataForPosting[0].zipCode = 0 : parseFloat(dataForPosting[0].zipCode);
      const formatedData = dataForPosting[0];

      axiosInstance?.current
        ?.post(url, [formatedData], config)
        .then((res) => {
          setOpenModal(true);
          setFinish(false);
          dataForPosting = [];
          console.log(res);
        })
        .catch((err) => {
          setFinish(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.pos.machineAdding") + t("toastr.general.failed.error500"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.pos.machineAdding") + t("toastr.general.failed.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.pos.machineAdding") + t("toastr.general.failed.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.pos.machineAdding") + t("toastr.general.failed.error204"));
          }
          console.log(err);
        });
    }
  };

  const [machineId, setMachineId] = useState(null);

  const putEditMachineEndpoint = (data) => {
    let dataForPosting = data;
    if (dataForPosting.length !== 0) {
      const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.putPosDevices}/${machineId}`;

      const clone = (({ id, merchantId, machineStatus, ...o }) => o)(dataForPosting);

      const dataObject = {
        ...clone,
        longitude: clone.longitude === "" ? (clone.longitude = 0) : parseFloat(clone.longitude),
        latitude: clone.latitude === "" ? (clone.latitude = 0) : parseFloat(clone.latitude),
        zipCode: clone.zipCode === "" ? (clone.zipCode = 0) : parseFloat(clone.zipCode),
      };

      const config = {
        headers: {
          Authorization: initialized ? `Bearer ${kcToken}` : undefined,
        },
      };
      axiosInstance?.current
        ?.put(url, dataObject, config)
        .then((res) => {
          setOpenModal(true);
          setFinishEdit(false);
          console.log(res);
        })
        .catch((err) => {
          setFinishEdit(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.pos.machineEdit") + t("toastr.general.failed.error204"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.pos.machineEdit") + t("toastr.general.failed.error204"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.pos.machineEdit") + t("toastr.general.failed.error204"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.pos.machineEdit") + t("toastr.general.failed.error204"));
          }
          console.log(err);
        });
    }
  };

  //OVERVIEW TABLE
  const renderDevicesTable = () => {
    return <DevicesTable dataForTable={devicesTableData} />;
  };

  const filterDevicesData = (data, selectedMachineStatuses, selectedMachineNames, selectedMachineCities, selectedMachineCheckboxes) => {
    const addStatusToDevices = data.map((device) => {
      if (device?.machineStatus === undefined) {
        device.machineStatus = MachineStatus.Unknown;
      }
      if (device?.longitude === 0 && device?.latitude === 0) {
        device.longitude = "";
        device.latitude = "";
      }
      return device;
    });

    const filteredData = addStatusToDevices.filter((machine) => {
      const acceptedValue = [true];
      const selectedMachineCheckboxesReduced = Object.keys(selectedMachineCheckboxes).reduce(function (r, e) {
        if (acceptedValue.includes(selectedMachineCheckboxes[e])) r[e] = selectedMachineCheckboxes[e];
        return r;
      }, {});

      const machineStatusCheckbox = Object.keys(selectedMachineCheckboxesReduced);
      const machineStatuses = (selectedMachineStatuses || []).map((selected) => selected.value);
      const machineCities = (selectedMachineCities || []).map((selected) => selected.value);
      const machineNamesOnly = (selectedMachineNames || []).map((selected) => selected.value);

      const status = !selectedMachineStatuses.length || machineStatuses.includes(machine.machineStatus);
      const city = !selectedMachineCities.length || machineCities.includes(machine.city);
      const name = !selectedMachineNames.length || machineNamesOnly.includes(machine.machineName);
      const checkbox = !machineStatusCheckbox.length || machineStatusCheckbox.includes(machine.machineStatus);
      return status && name && city && checkbox;
    });
    //setFilteredMachineData(filteredData.length ? filteredData : machinesData)
    setFilteredMachineData(filteredData);

    return filteredData;
  };

  const calculateDevicesTableData = (machinesDataResponseData, isSelected) => {
    if (isSelected) {
      const uniqueMachineNames = [...new Set(Object.values(machinesDataResponseData).map((machine) => machine.machineName))];

      setMachineNames(uniqueMachineNames);
      //console.log("Machine names => " , {machinesDataResponseData}, ", Unique => ", {uniqueMachineNames})
    } else {
      setMachineNames([]);
    }

    const tableData = machinesDataResponseData.map((machine) => {
      return {
        Status: machine.machineStatus,
        Time: machine.end_timestamp || machine.start_timestamp || EMPTY_DATA_DASH,
        Information: machine.errorCodeDescription || EMPTY_DATA_DASH,
        "Operator ID": machine.operatorId,
        "Device ID": machine?.deviceId.toString(),
        City: machine.city,
        Address: machine.address.length > 0 ? machine.address + ", " + machine.streetNumber : EMPTY_DATA_DASH,
      };
    });

    setDevicesTableData(tableData);
  };

  const calculateDevicesCards = (machinesDataResponseData) => {
    //console.log("RESPONSE MACHINE", res.data, machinesDataResponseData)
    // SET DATA FROM BACKEND
    filterDevicesData(machinesDataResponseData, [], [], [], { ok: true, error: true, warning: true, unknown: true }, undefined);

    setMachineData(machinesDataResponseData);

    // MACHINE STATUSES (filter-out EMPTY values)
    const uniqueMachineStatuses = [
      ...new Set(machinesDataResponseData.filter((machine) => machine?.machineStatus !== "").map((machine) => machine.machineStatus)),
    ];

    setMachineStatuses(uniqueMachineStatuses);

    // MACHINE CITIES (filter-out EMPTY values)
    const uniqueMachineCities = [...new Set(machinesDataResponseData.filter((machine) => machine?.city !== "").map((machine) => machine.city))];
    setMachineCities(uniqueMachineCities);

    const totalDevices = machinesDataResponseData.length;
    setTotalNumberOfDevices(totalDevices);

    //2. Total number of WORKING machines
    setTotalWorking(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Working).length);

    //3. Total number of WARNING machines
    setTotalWarning(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Warning).length);

    //4. Total number of ERROR machines
    setTotalError(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Error).length);

    //5. Total number of UNKNOWN machines
    setTotalUnknown(machinesDataResponseData.filter((machine) => machine.machineStatus === MachineStatus.Unknown).length);
  };

  const getMachineStatesBufferedEndpoint = (startDate, endDate) => {
    setLoadingFlag(true);

    const newBackendUrl = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.getAllPosDevices}`;

    axiosInstance?.current
      ?.get(newBackendUrl)
      .then((res) => {
        setLoadingFlag(false);

        //console.log("POS NEW BACKEND", res?.data);

        const machinesDataResponseDataNewBack = res?.data || [];

        const addStatusToDevices = machinesDataResponseDataNewBack.map((device) => {
          if (device?.machineStatus === undefined) {
            device.machineStatus = MachineStatus.Unknown;
          }
          return device;
        });

        calculateDevicesTableData(addStatusToDevices, false);
        calculateDevicesCards(addStatusToDevices);
      })
      .catch((err) => {
        setLoadingFlag(false);
        if (err?.response?.status === 500) {
          ShowToastMessage(t("toastr.pos.machineFetch") + t("toastr.general.failed.error500"));
        } else if (err?.response?.status === 401) {
          ShowToastMessage(t("toastr.pos.machineFetch") + t("toastr.general.failed.error401"));
        } else if (err?.response?.status === 404) {
          ShowToastMessage(t("toastr.pos.machineFetch") + t("toastr.general.failed.error404"));
        } else if (err?.response?.status === 204) {
          ShowToastMessage(t("toastr.pos.machineFetch") + t("toastr.general.failed.error204"));
        }
        console.log("DEVICES ERROR", err);
      });
  };

  const deletePOSMachine = (machineId) => {
    setLoadingFlag(true);

    const newBackendUrl = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.deletePosDevices}/${machineId}`;

    axiosInstance?.current
      ?.delete(newBackendUrl)
      .then((res) => {
        getMachineStatesBufferedEndpoint();
        navigate(`${process.env.PUBLIC_URL}${DASHBOARD_ROUTES.ROOT}${DASHBOARD_ROUTES.POS_PAGE}/`);
        setLoadingFlag(false);
      })
      .catch((err) => {
        setLoadingFlag(false);
        if (err?.response?.status === 500) {
          ShowToastMessage(t("toastr.pos.machineDeletion") + t("toastr.general.failed.error500"));
        } else if (err?.response?.status === 401) {
          ShowToastMessage(t("toastr.pos.machineDeletion") + t("toastr.general.failed.error401"));
        } else if (err?.response?.status === 404) {
          ShowToastMessage(t("toastr.pos.machineDeletion") + t("toastr.general.failed.error404"));
        } else if (err?.response?.status === 204) {
          ShowToastMessage(t("toastr.pos.machineDeletion") + t("toastr.general.failed.error204"));
        }
        console.log("DELETE MACHINE ERROR", err);
      });
  };

  const callPeriodDataFetch = (startDate, endDate) => {
    getMachineStatesBufferedEndpoint(startDate, endDate);
  };

  useEffect(() => {
    if (initialized) {
      if (merchantId !== undefined) {
        getMachineStatesBufferedEndpoint(startDate, endDate);
        //setDevicesTableData([])
        //getmachineGroup();
      }
    }
  }, [initialized, merchantId]);

  return {
    startDate,
    endDate,
    machinesData,
    machinesDataCardsData: [
      //{ title: "Total Devices", subtitle: "Total Number of Devices", value: totalNumberOfDevices, type: "number" },
      {
        title: `${t("POS.cards.total")}`,
        subtitle: `${t("POS.cards.totalMachines")}`,
        value: totalNumberOfDevices,
        type: "number",
      },
      {
        title: `${t("POS.cards.working_up")}`,
        subtitle: `${t("POS.cards.workingMachines")}`,
        value: totalWorking,
        type: "number",
      },
      {
        title: `${t("POS.cards.warning_up")}`,
        subtitle: `${t("POS.cards.warningMachines")}`,
        value: totalWarning,
        type: "number",
      },
      {
        title: `${t("POS.cards.error_up")}`,
        subtitle: `${t("POS.cards.errorMachines")}`,
        value: totalError,
        type: "number",
      },
      {
        title: `${t("POS.cards.unknown_up")}`,
        subtitle: `${t("POS.cards.unknownMachines")}`,
        value: totalUnknown,
        type: "number",
      },
    ],
    setFinish,
    finish,
    finishEdit,
    setFinishEdit,
    machineStatuses,
    machineCities,
    machineNames,
    machineGroup,
    //deviceLocations,
    callFilter: (startDate, endDate) => callPeriodDataFetch(startDate, endDate),
    calculateDevicesTableData,
    filterDevicesData,
    devicesTableData,
    SearchableDevicesTable: renderDevicesTable(),
    //DevicesManagmentBackendTable: renderDevicesTableNewBackEnd(),
    ImportedBulkTable: renderBulkTable(),
    filteredMachineData,
    getMachineStatesBufferedEndpoint,
    deletePOSMachine,
    setSelectedDevices,
    setSelectedDevicesLength,
    setAllDevices,
    postNewMachineEndpoint,
    postBulkMachineEndpoint,
    putEditMachineEndpoint,
    getmachineGroup,
    setMachineAddStatus,
    setIsRequestGood,
    setOpenModal,
    setOpenModalForDelete,
    machineAddStatus,
    postingFlag,
    isRequestGood,
    openModal,
    openModalForDelete,
    allRows,
    selectedRows,
    loadingFlag,
    areMachinesVisible,
    setAreMachinesVisible,
    addNewDeviceData,
    setEditableMachine,
    setMachineId,
    machineId,
    editableMachine,
  };
};
